<template>
<div class="createorder_qg" v-if="isload">
		<el-form style="margin-bottom:45px;">
			<el-row>
				<maininfo :ref="'main_'+l_id" :item="item" :l_id="l_id" @maincallback="maincallback" :defaulttitle="createorder_qg_lang.maintitle"></maininfo>
			</el-row>
			<el-row>
				<maininfo :ref="'maincargo_'+l_id" :item="item" :l_id="l_id" @maincallback="maincallback" :defaulttitle="createorder_qg_lang.maincargotitle"></maininfo>
			</el-row>
			<el-row>
				<el-col :span="24" style="text-align:center;"><el-button @click="addcargo(true)" type="primary" size="mini">{{createorder_qg_lang.addcargoclear}}</el-button>
					<el-button @click="addcargo(false)" type="warning" size="mini"  style="margin-left:10px;">{{createorder_qg_lang.addcargo}}</el-button>
					<el-button @click="resetcargo" size="mini" style="margin-left:10px;">{{createorder_qg_lang.resetcargo}}</el-button></el-col>
			</el-row>
			<el-row>
				<gridlist :ref="'cargolist_'+l_id" :item="item" :l_id="l_id" @gridcallback="gridcallback" :isadd="false" :ischecksingle="true"></gridlist>
			</el-row>
		</el-form>
		<el-row class="footerhandler" v-if="!btndisabled">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="saveorder">{{$lang.label.public.savebtn}}</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{$lang.label.public.cancel}}</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import maininfo from '@/components/tools/maininfo.vue';
import gridlist from '@/components/tools/gridlist.vue';
export default {
	components: {
		maininfo,
		gridlist
	},
	props: {
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		l_id:{
			type: String,
			default:''
		}
	},
	data() {
		return {
			syscol: '',
			orderinfo:'',
			p_pkval:'',
			// pkval:'',
			iscopy: 0,
			btndisabled: false,
			isload: false,
			checkedpmode: '',
			t_id: '',
			showsuccesswin: false,
			wintips: false,
			divclass:'createorder_qg',
			pagetranscol:'',
			type:'',
			createorder_qg_lang:{},
			rowindex:0
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			var that = this;
			this.isload = false;
			if (param.checkedpmode != undefined) this.checkedpmode = param.checkedpmode;
			if (param.syscol != undefined) this.syscol = param.syscol;
			if (param.orderinfo != undefined) this.orderinfo = param.orderinfo;
			
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.t_id != undefined) this.t_id = param.t_id;
			if(param.pagetranscol!=undefined) this.pagetranscol=param.pagetranscol;
			if(param.pkval!=undefined) this.p_pkval=param.pkval;
			if(param.type!=undefined) this.type=param.type;
			
			if(this.p_pkval=='')
				this.orderinfo='';
			if (this.syscol != '') {
				this.isload = true;
				if(this.orderinfo!=''&&this.pagetranscol!=''){
					this.orderinfo = this.$tool.TransOrderInfo(this.pagetranscol, this);
				}
			}
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('createorder_qg',this).then(res=>{
				if(res.state=='1'){}
					that.createorder_qg_lang=that.$lang.label.createorder_qg;
				//debugger
				this.$nextTick(function() {
					that.$refs['main_'+that.l_id].init({pkval:that.p_pkval,iscopy:that.iscopy,type:that.type,orderinfo:that.orderinfo,syscol:that.syscol,t_id: that.t_id});
					that.$refs['maincargo_'+that.l_id].init({pkval:that.p_pkval,iscopy:that.iscopy,type:that.type+'-cargo',orderinfo:that.orderinfo,syscol:that.syscol,t_id: that.t_id});
					that.$refs['cargolist_'+that.l_id].init({pkval:that.p_pkval,iscopy:that.iscopy,type:that.type,orderinfo:that.orderinfo,syscol:that.syscol,t_id: that.t_id,ischecked:true});
				});
			});
		},
		maincallback(e){
			
		},
		gridcallback(e){
			if(e.rowindex!='-1'){
				this.rowindex=e.rowindex;
				this.$refs['maincargo_'+this.l_id]._data.orderinfo={maincargo:e.row};
				this.$refs['maincargo_'+this.l_id].setinfovalue();
			}
			else
				this.rowindex=undefined;
		},
		saveorder(){
			var that=this;
			var orderinfo=this.$tool.getOrderinfo(this.$refs['main_'+this.l_id]._data,this.p_no,this);
			if(orderinfo!=''){
				orderinfo=this.$tool.getOrderinfo(this.$refs['cargolist_'+this.l_id]._data,this.p_pkval,this,orderinfo);
			}
			if(orderinfo!=''){
				if(orderinfo.cargolist.length==0){
					this.$tool.message(that.$lang.label.public.cargolistempty, "0");
					return false;
				}
				//debugger
				orderinfo.u_userid=localStorage.getItem('userid');
				orderinfo.t_id=that.t_id;
				if(this.iscopy==0&&this.p_pkval!='')
				{
					orderinfo.editid=this.p_pkval;
				}
				this.btndisabled=true;
				this.$tool.loading(that.$lang.label.public.saving, this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					this.btndisabled=false;
					if (res.state == '1') {
						this.$tool.message(that.$lang.label.public.savesuccess, "1");
						setTimeout(function(){
							that.cancel();
						},1000);
					}
					else
						this.$tool.message(res.message, "0");
						//this.$tool.message(that.baojia_lang[res.message], "0");
				});
			}
		},
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		addcargo(isclear){
			var row=this.$tool.getOrderinfo(this.$refs['maincargo_'+this.l_id]._data,undefined,this);
			if(row!=''){
				this.$refs['cargolist_'+this.l_id].addnewrow(row,this.rowindex);
				this.$tool.message(this.$lang.label.public.savesuccess,1);
				this.rowindex=undefined;
				if(isclear){
					this.resetcargo();
				}
			}
		},
		resetcargo(){
			var row=this.$tool.getOrderinfo(this.$refs['maincargo_'+this.l_id]._data,undefined,this);
			for(var i in row)
				row[i]="";
			this.$refs['maincargo_'+this.l_id]._data.orderinfo={maincargo:row};
			this.$refs['maincargo_'+this.l_id].setinfovalue();	
		}
	}
}
</script>

<style>
</style>